import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { AppMetaState } from './app-meta.reducer';

export const selectAppMetaInformation = (state: AppState) => state.appMetaState;

export const selectPageEnabledStatus = createSelector(
  selectAppMetaInformation,
  (state: AppMetaState) => state.metaData.disablePage
);

export const selectLoadingSpinnerStatus = createSelector(
  selectAppMetaInformation,
  (state: AppMetaState) => state.metaData.stopLoadingSpinner
);

export const selectNoConfigDataStatus = createSelector(
  selectAppMetaInformation,
  (state: AppMetaState) => state.metaData.noConfigData
);

// TODO: Check if we need this at all
export const selectLanguage = createSelector(selectAppMetaInformation, (state: AppMetaState) => state.metaData.lng);
/* 
export const selectCountry = createSelector(selectAppMetaInformation, (state: AppMetaState) => state.metaData.country);
 */
export const selectAppMeta = createSelector(selectAppMetaInformation, (state: AppMetaState) => state.metaData);
